import { render, staticRenderFns } from "./ContentHeader.vue?vue&type=template&id=f2ac80f2&"
import script from "./ContentHeader.vue?vue&type=script&lang=ts&"
export * from "./ContentHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports